export default {
    /* GET_NETTO_MARK_UP
    ---------------------------------------------------------------
    */
    GET_NETTO_MARK_UPS_REQUEST: (state) => {
        state.nettoMarkUpsLoading = true
    },
    GET_NETTO_MARK_UPS_SUCCESS: (state, data) => {
        state.nettoMarkUps = data
        state.nettoMarkUpsLoading = false
    },
    GET_NETTO_MARK_UPS_FAILURE: (state) => {
        state.nettoMarkUpsLoading = false
    },
    SET_NETTO_MARK_UPS_FILTERS: (state, filters) => {
        state.filters = filters
    },
    CLEAR_NETTO_MARK_UPS_FILTERS: state => {
        state.filters = state.setInitialFilters()
    }
}